// Customer data for LEION Engineering - REAL CLIENT LIST FROM AFRICA

// Main highlighted customers for scrolling banner - ONLY companies with logos
export const CUSTOMERS = [
  // Ghana - Major Clients
  {
    id: 'cocobod',
    name: 'COCOBOD Ghana',
    country: 'Ghana',
    logo: '/assets/customers/cocobod.png',
  },
  {
    id: 'ghana-highway',
    name: 'Ghana Highway Authority (GHA)',
    country: 'Ghana',
    logo: '/assets/customers/ghana-highway.jpg',
  },
  {
    id: 'diamond-cement',
    name: 'Diamond Cement Group',
    country: 'Ghana',
    logo: '/assets/customers/diamond-cement.png',
  },
  {
    id: 'olam',
    name: 'OLAM Ghana',
    country: 'Ghana',
    logo: '/assets/customers/olam.jpg',
  },
  {
    id: 'justmoh',
    name: 'Justmoh Construction',
    country: 'Ghana',
    logo: '/assets/customers/justmoh.png',
  },
  {
    id: 'polytank',
    name: 'Polytank Ghana',
    country: 'Ghana',
    logo: '/assets/customers/polytank.png',
  },
  {
    id: 'ministry-health',
    name: 'Ministry of Health Ghana',
    country: 'Ghana',
    logo: '/assets/customers/ministry-health.png',
  },
  {
    id: 'kingdom-eximp',
    name: 'Kingdom Exim Group',
    country: 'Ghana',
    logo: '/assets/customers/kingdom-exim.png',
  },
  {
    id: 'printex',
    name: 'Printex Ghana',
    country: 'Ghana',
    logo: '/assets/customers/printex.png',
  },
  {
    id: 'pharmanova',
    name: 'Pharmanova Ghana',
    country: 'Ghana',
    logo: '/assets/customers/pharmanova.png',
  },
  // Ivory Coast Client
  {
    id: 'rafmoh',
    name: 'RAFMOH Group',
    country: 'Ivory Coast',
    logo: '/assets/customers/rafmoh.png',
  },
  // Togo
  {
    id: 'star-metal',
    name: 'Star Metal Sarl',
    country: 'Togo',
    logo: '/assets/customers/star-metal.png',
  },
  // Burkina Faso
  {
    id: 'cim-metal',
    name: 'CIM Metal Group',
    country: 'Burkina Faso',
    logo: '/assets/customers/cim-metal.png',
  },
  // UAE / Dubai
  {
    id: 'alkhaleej-steel',
    name: 'Al Khaleej Steel Limited',
    country: 'Dubai, UAE',
    logo: '/assets/customers/alkhaleej-steel.png',
  },
  {
    id: 'galaxy-metals',
    name: 'Galaxy Metals FZE',
    country: 'UAE',
    logo: '/assets/customers/galaxy-metals.png',
  },
  // Liberia
  {
    id: 'lutech',
    name: 'Lutech Engineering',
    country: 'Liberia',
    logo: '/assets/customers/lutech.png',
  },
];

// Full client list by country for reference
export const ALL_CLIENTS = {
  ghana: [
    { name: 'COCOBOD Ghana', location: 'Asokwa Kumasi' },
    { name: 'Ghana Highway Authority', location: 'Multiple Locations' },
    { name: 'Tema Steel', location: 'Tema' },
    { name: 'OLAM Ghana', location: 'Tumu' },
    { name: 'OLAM Biscuit Ghana Ltd', location: 'Tema' },
    { name: 'Diamond Cement (Gh) Ltd', location: 'Aflao' },
    { name: 'Western Diamond Cement', location: 'Takoradi' },
    { name: 'Savana Diamond Company Ltd', location: 'Buipe' },
    { name: 'Justmoh Construction', location: 'Ghana, Suhum, Takoradi' },
    { name: 'Kingdom Exim Ghana Ltd', location: 'Tema, Techiman, Japekrom' },
    { name: 'Printex Ghana', location: 'Ghana' },
    { name: 'Fuel Trade Ltd', location: 'Tema' },
    { name: 'ETG Limited', location: 'Tema' },
    { name: 'GADCO Agro Ltd', location: 'Sogakope' },
    { name: 'Rider Steel Ghana Ltd', location: 'Tema' },
    { name: 'Xenon Steel Ghana Ltd', location: 'Tema' },
    { name: 'Apollo Steel Ghana Ltd', location: 'Tema' },
    { name: 'Imperial Alloys Ghana Ltd', location: 'Tema' },
    { name: 'Ferrofebrik Ghana Ltd', location: 'Free Zone Tema' },
    { name: 'Fabri Metal Ghana Ltd', location: 'Tema' },
    { name: 'Ghana Steel Ltd', location: 'Kpone-Tema' },
    { name: 'Sethi Steel Manufacturing Ltd', location: 'Kumasi' },
    { name: 'Western Rod Ghana Ltd', location: 'Tema' },
    { name: 'Maranga Steel', location: 'Kumasi' },
    { name: 'Polytank Ghana Ltd', location: 'Tema, Kumasi' },
    { name: 'PEPSI COLA', location: 'Accra' },
    { name: 'GB Foods Ltd', location: 'Tema' },
    { name: 'Nutrifoods Ghana Ltd', location: 'Tema' },
    { name: '3F Ghana Ltd', location: 'Tema' },
    { name: 'Avnash Ghana Ltd', location: 'Ghana' },
    { name: 'Eskay Pharma', location: 'Ghana' },
    { name: 'Nova Pharma', location: 'Ghana' },
    { name: 'Golden Star Resources', location: 'Bogoso' },
    { name: 'Ghana Bauxite Mining Ltd', location: 'Tarkwa' },
    { name: 'Mineral Commission Ghana', location: 'Apemanim, Awaso' },
    { name: 'ESM Quarry Ltd', location: 'Kumasi' },
    { name: 'Monsco Quarry Ghana Ltd', location: 'Ghana' },
    { name: 'Action Quarry', location: 'Nswam' },
    { name: 'Justmac Quarry', location: 'Takoradi' },
    { name: 'Manson Quarry', location: 'Ghana' },
    { name: 'Frank Batching Plant', location: 'Ghana' },
    { name: 'Cofco Ghana Ltd', location: 'Tema' },
    { name: 'Seven Seas Salt Ltd', location: 'Adina Volta Region' },
  ],
  nigeria: [
    { name: 'Dangote Cement Nig Ltd', location: 'Nigeria' },
    { name: 'Metafarique', location: 'Nigeria' },
    { name: 'Bolewale Int Ltd', location: 'Nigeria' },
    { name: 'Legent Metal Ltd', location: 'Nigeria' },
    { name: 'Silver Stone Overseas', location: 'Nigeria' },
    { name: 'Lesag Nigeria Limited', location: 'Nigeria' },
    { name: 'Metal Recycling Ltd', location: 'Nigeria' },
    { name: 'Phoenix Steel Ltd', location: 'Nigeria' },
    { name: 'Dolphin Steel Ltd', location: 'Nigeria' },
    { name: 'IFE Steel Nig Ltd', location: 'Nigeria' },
    { name: 'Pulkit Steel Nig Ltd', location: 'Nigeria' },
    { name: 'Everest Metal Nig Ltd', location: 'Nigeria' },
    { name: 'Ranbaxy Nigeria Limited', location: 'Nigeria' },
    { name: 'Pardi Foods Nigeria Ltd', location: 'Nigeria' },
  ],
  ivoryCoast: [
    { name: 'RAFMOH IVC SARL', location: 'Abidjan' },
    { name: 'King Ivory Steel Ltd', location: 'Ivory Coast' },
    { name: 'Yantra Tech International SARL', location: 'Ivory Coast' },
    { name: 'Baxy Export Ltd', location: 'Ivory Coast' },
    { name: 'Africa International SARL', location: 'Abidjan' },
    { name: 'Premier Foods SARL', location: 'Abidjan' },
    { name: 'Ivoire Trade International', location: 'Abidjan' },
    { name: 'AAMCO SARL', location: 'Abidjan' },
    { name: 'Pharma Nova SARL', location: 'Abidjan' },
    { name: 'HISAS SARL', location: 'Abidjan' },
    { name: 'Brentwood Engineering Ltd', location: 'Ivory Coast' },
    { name: 'A3T Services SA', location: 'Ivory Coast' },
    { name: 'Afic Logistic', location: 'Abidjan' },
  ],
  togo: [
    { name: 'WACEM SA', location: 'Lome Port Terminal' },
    { name: 'Fortia Cement SA', location: 'Togo' },
    { name: 'West African Cement', location: 'Togo' },
    { name: 'Diamond Cement SA', location: 'Togo' },
    { name: 'Metworld SA', location: 'Togo' },
    { name: 'SITRAPAT SA', location: 'Togo' },
    { name: 'Star Metal Sarl', location: 'Togo' },
    { name: 'SA International Sarl', location: 'Togo' },
    { name: 'Santbon SAS', location: 'Togo' },
  ],
  mali: [
    { name: 'Sahara Mining SARL', location: 'Bamako' },
    { name: 'Maa Tara Batching Plant & Construction SARL', location: 'Mali' },
    { name: 'Mandey Mining Sarl', location: 'Mali' },
    { name: 'Yantra Tech International SARL', location: 'Mali' },
    { name: 'Al Ain Exim SARL', location: 'Mali' },
  ],
  burkinaFaso: [
    { name: 'Ranch Koba Sarl', location: 'Burkina Faso' },
    { name: 'CIM Faso SA', location: 'Ouagadougou' },
    { name: 'ETS Sokasi Intl SARL', location: 'Burkina Faso' },
    { name: 'HBT SA', location: 'Burkina Faso' },
    { name: 'CIM Metal SARL', location: 'Burkina Faso' },
    { name: 'Sucotrop Sarl', location: 'Burkina Faso' },
  ],
  liberia: [
    { name: 'Lutech Engineering Ltd', location: 'Liberia' },
    { name: 'CONEX Petroleum', location: 'Liberia' },
    { name: 'SWL', location: 'Liberia' },
  ],
  sierraLeone: [
    { name: 'Leocem Ltd', location: 'Sierra Leone' },
    { name: 'Kissy Industry', location: 'Sierra Leone' },
    { name: 'SWL', location: 'Sierra Leone' },
  ],
  tanzania: [
    { name: 'Mount Meru Limited', location: 'Arusha' },
  ],
  ethiopia: [
    { name: 'Dangote Cement Ltd', location: 'Ethiopia' },
  ],
  uae: [
    { name: 'Rafmoh FZE LTD', location: 'UAE' },
    { name: 'Alkhaleej Steel Ltd', location: 'UAE' },
    { name: 'Galaxy Metal FZC', location: 'UAE' },
    { name: 'Farmington Foods FZCO', location: 'Dubai' },
  ],
  senegal: [
    { name: 'AG ALLOYS SARL', location: 'Senegal' },
    { name: 'Fabrimetal', location: 'Senegal' },
    { name: 'Kelogs Intl Sarl', location: 'Senegal' },
  ],
  guinea: [
    { name: 'AG ALLOYS SARL', location: 'Conakry' },
    { name: 'BLESS METAL', location: 'Guinea Conakry' },
  ],
  niger: [
    { name: 'Zubeko Intl', location: 'Niger' },
    { name: 'ETS Sokasi Intl SARL', location: 'Niger' },
    { name: 'Ken Metal SARL', location: 'Niger' },
    { name: 'Al Noor Intl SARL', location: 'Niger' },
  ],
  gabon: [
    { name: 'Gulucom', location: 'Gabon' },
  ],
  cameroon: [
    { name: 'Comagri CAM SARL', location: 'Cameroon' },
  ],
  congo: [
    { name: 'Diamond Cement', location: 'Congo' },
  ],
  somalia: [
    { name: 'Hassan Steel Trading Ltd', location: 'Hargasa' },
  ],
};

// Global Sales Partners
export const GLOBAL_PARTNERS = [
  {
    id: 'hercules',
    name: 'Hercules International',
    country: 'Dubai, UAE',
    role: 'Business Associate',
    logo: '/assets/customers/hercules.jpg',
  },
];

// Certifications
export const CERTIFICATIONS = [
  {
    id: 'iso',
    name: 'ISO 9001:2015',
    certificateNumber: '23MEQPT45',
    dateIssued: '02/01/2024',
    validUntil: '01/01/2027',
    scope: 'Manufacturer, Trader & Exporter of Electronic Weighing Machine, Weighbridge, Inverters, Axle Weigh Pad, Axle Weighing Scale and Solar Products',
    pdfUrl: '/assets/docs/iso-le.pdf',
  },
  {
    id: 'ce',
    name: 'CE Certification',
    certificateNumber: 'UQ-3168',
    dateIssued: '30/12/2023',
    validUntil: '29/12/2026',
    standard: 'Personal Protective Equipment Directive 89/686/EEC',
    scope: 'Electronic Weighing Machine, Weighbridge, Inverters, Axle Weigh Pad, Axle Weighing Scale and Solar Products',
    pdfUrl: '/assets/docs/ce-le.pdf',
  },
];
